export enum UserType {
  PERSONAL = 'PERSONAL',
  BUSINESS = 'BUSINESS',
  AGENT = 'AGENT',
  MERCHANT = 'MERCHANT',
}
